import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useWordPressMenuHighlight = () => {
    const location = useLocation(); // Works with react-router

    useEffect(() => {
        const slug = 'ultimate-security';
        const selector = 'a.toplevel_page_' + slug;
        const link = document.querySelector(selector);

        if (link) {
            // Always add current classes
            link.classList.add( 'wp-has-current-submenu');

            if (link.parentElement) {
                link.parentElement.classList.add('wp-has-current-submenu', 'wp-menu-open');
            }
        }

        // Optional: Clean up classes if you want to support switching away
        // Uncomment the below lines if needed
        /*
        return () => {
            if (link) {
                link.classList.remove('current', 'wp-has-current-submenu');
                if (link.parentElement) {
                    link.parentElement.classList.remove('wp-has-current-submenu', 'wp-menu-open');
                }
            }
        };
        */
    }, [location.pathname, location.hash]); // Runs on first load and every route change
};

export default useWordPressMenuHighlight;

